import React from 'react';

/**
 * Sort
 *
 * @param {Object} props
 * @param {string} props.context
 * @param {Object} props.setStart
 */
const InputList = ({ options, type, name, label, checked, onChangeHandler }) => {
  const formatLabel = ( str ) => str.toLowerCase().replace( /[^\w\s]/gi, '' ).replace( ' ', '-' );

  return (
    <ul className="filters__submenu text-14 text-[#121212] flex-col gap-15 list-none ml-0 mb-20 pl-0">
      { options.map( ( item ) => (
        <li className="submenu__list-item mb-0" key={ self.crypto.randomUUID() }>
          <input
            className='submenu__input mr-10 hidden'
            id={ label ? formatLabel( item.label ) : item.value }
            type={ type }
            name={ name }
            value={ item.value }
            onChange={ onChangeHandler }
            checked={ checked === formatLabel( item.label ) ? 'checked' : !label && checked === item.value ? 'checked' : null }
            data-direction={ item.direction ?? null }
            data-value={ item.value }
          />
          <label className='submenu__input-label cursor-pointer relative flex items-center pl-33' htmlFor={ label ? formatLabel( item.label ) : item.value }>
            <span dangerouslySetInnerHTML={ { __html: item.label } } />
          </label>
        </li>

      ) ) }
    </ul>

  );
};

export default InputList;
